module.exports = __webpack_public_path__ + "static/BradWadeResumeNovember2019-5c121809fe97fd9bf163dcc7d2673006.pdf";